import React, { useState } from 'react';
import { Plus, Download, Printer, Share2 } from 'lucide-react';
import { useFamilyStore } from '../../store/familyStore';
import { buildUrl } from '../../utils/routing';
import { UnifiedMemberModal } from '../Forms/UnifiedMemberModal';

export const BottomNavigation: React.FC = () => {
  const { stats, isAdminView, currentFamilyTreeId } = useFamilyStore();
  const [showAddModal, setShowAddModal] = useState(false);

  const generations = Array.from({ length: stats.totalGenerations }, (_, i) => i + 1);

  const handleExport = async () => {
    const canvasEl = document.querySelector('.react-flow') as HTMLElement | null;
    if (!canvasEl) return;

    const html2canvas = (await import('html2canvas')).default;
    try {
      const canvas = await html2canvas(canvasEl, {
        backgroundColor: '#ffffff',
        scale: 2,
        useCORS: true,
        allowTaint: true,
      });
      const link = document.createElement('a');
      link.download = 'family-tree.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    } catch (e) {
      console.error('Export failed:', e);
      alert('Export failed. Please try again.');
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const handleShare = async () => {
    if (!currentFamilyTreeId) return;
    const url = `${window.location.origin}${buildUrl(`/family-tree/${currentFamilyTreeId}`)}`;
    try {
      if (navigator.share) {
        await navigator.share({ title: 'Family Tree', url });
        return;
      }
      await navigator.clipboard.writeText(url);
      alert('Link copied to clipboard!');
    } catch (e) {
      console.warn('Share failed:', e);
    }
  };

  return (
    <>
      <div className="bg-white border-t border-gray-200 px-3 py-2">
        <div className="flex flex-wrap items-center justify-between gap-2">
          {/* Generation Tabs */}
          <div className="flex items-center space-x-1">
            <span className="text-sm font-medium text-gray-700 mr-2">© {new Date().getFullYear()} Munshis. All rights reserved.</span>
          </div>

          {/* Quick Actions */}
          <div className="flex items-center space-x-2">
            {isAdminView && (
              <button
                onClick={() => setShowAddModal(true)}
                className="flex items-center space-x-1 px-3 py-1.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
              >
                <Plus className="w-4 h-4" />
                <span className="hidden sm:inline">Add Member</span>
              </button>
            )}

            <button
              onClick={handleExport}
              className="flex items-center space-x-1 px-3 py-1.5 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
            >
              <Download className="w-4 h-4" />
              <span className="hidden sm:inline">Export</span>
            </button>

            <button
              onClick={handlePrint}
              className="hidden sm:flex items-center space-x-1 px-3 py-1.5 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
            >
              <Printer className="w-4 h-4" />
              <span>Print</span>
            </button>

            <button
              onClick={handleShare}
              className="hidden sm:flex items-center space-x-1 px-3 py-1.5 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
            >
              <Share2 className="w-4 h-4" />
              <span>Share</span>
            </button>
          </div>
        </div>
      </div>

      <UnifiedMemberModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
      />
    </>
  );
};